import { MinLength, MaxLength } from "class-validator";
import {validate, validateOrReject, Contains, IsInt, Length, IsEmail, IsFQDN,
        IsDate,Min,Max } from "class-validator"; 
import {ValidateIf, IsNotEmpty,IsNumber,IsString,IsEmpty } from "class-validator"; 


export class Openwin { 
    @MaxLength(10,{message: 'COMPANY 字串太長'}) 
    @IsString({message: 'COMPANY 不是字串型態'}) 
    COMPANY: string = ""; 
  
    @MaxLength(10) 
    CREATOR: string = ""; 
  
    @MaxLength(10) 
    USR_GROUP: string = ""; 
  
    @MaxLength(8) 
    CREATE_DATE: string =""; 
  
    @MaxLength(10) 
    MODIFIER: string = ""; 
  
    @MaxLength(8) 
    MODI_DATE: string = ""; 
  
    @IsNumber() 
    @Max(999) 
    FLAG: number =0; 



    CreateDate: Date | undefined;            // 建立日期 0 

    @MaxLength(50,{message: '建檔者 (CreateUserID) 資料太長'})
    CreateUserID: string = '';            // 建檔者 50 

    @IsNotEmpty({message: '顯示 (Display) 不可空白'}) 
    Display: string = '';            // 顯示 0 

    @IsNotEmpty({message: '序號 (ITEM) 不可空白'}) 
    @MaxLength(50,{message: '序號 (ITEM) 資料太長'})
    ITEM: string = '';            // 序號 50 

    @IsNotEmpty({message: '主資料表 (MainTable) 不可空白'}) 
    @MaxLength(50,{message: '主資料表 (MainTable) 資料太長'})
    MainTable: string = '';            // 主資料表 50 

    @IsNotEmpty({message: 'MAP (MAP) 不可空白'}) 
    MAP: string = '';            // MAP 0 


    ModiDate: Date | undefined;            // 修改日期 0 

    @MaxLength(255,{message: '備註 (PS) 資料太長'})
    PS: string = '';            // 備註 255 

    SQLOrder: string = '';            // 欄位排序 0 

    SQLReturn: string = '';            // SQLReturn 0 

    @IsNotEmpty({message: 'SQLSelect (SQLSelect) 不可空白'}) 
    SQLSelect: string = '';            // SQLSelect 0 

    @IsNotEmpty({message: 'SQLWhere (SQLWhere) 不可空白'}) 
    SQLWhere: string = '';            // SQLWhere 0 

    @MaxLength(50,{message: '標題 (Title) 資料太長'})
    Title: string = '';            // 標題 50 

    @IsNotEmpty({message: '類別 (TYPE) 不可空白'}) 
    @MaxLength(1,{message: '類別 (TYPE) 資料太長'})
    TYPE: string = '';            // 類別 1 


}
